<div class="container container-shadow py-5 mt-3 mb-5">
  <h3>{{ globalTax.id ? 'Editing' : 'New' }} Global Tax</h3>
  <hr />
  <form #currentForm="ngForm" novalidate>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-sm-3 col-md-2">
            <label>Name</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input [ngClass]="{ 'is-invalid': name.errors && formSubmitted }" #name="ngModel" required type="text" class="form-control" name="name" [(ngModel)]="globalTax.name" />
            <div class="invalid-feedback">Name is required</div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Amount</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input type="number" [ngClass]="{ 'is-invalid': amount.errors && (amount.errors.required || amount.errors.invalidNumber) && formSubmitted }" required #amount="ngModel" name="amount" [(ngModel)]="globalTax.amount" class="form-control" appNumberValidator />
            <div class="invalid-feedback">
              <div *ngIf="amount.errors && amount.errors.required">Amount is required</div>
              <div *ngIf="amount.errors && amount.errors.invalidNumber">Amount should be a number</div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Cutoff</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input #cutoff="ngModel" [ngClass]="{ 'is-invalid': cutoff.errors && formSubmitted }" required type="number" class="form-control" name="cutoff" [(ngModel)]="globalTax.cutoff" />
            <div class="invalid-feedback">Cutoff is required</div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Frequency</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <select class="form-control" name="frequency" [(ngModel)]="globalTax.frequency">
              <option *ngFor="let frequency of formOptions.frequencies" [value]="frequency.value">{{ frequency.label }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Way</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <select class="form-control" name="way" [(ngModel)]="globalTax.way">
              <option *ngFor="let way of formOptions.ways" [value]="way.value">{{ way.label }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col text-center">
            <button type="button" class="btn btn-primary" [disabled]="formSubmitting" (click)="save(currentForm.form.valid)">
              {{ formSubmitting ? 'Saving' : 'Save' }}<span *ngIf="formSubmitting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span></button
            >&nbsp;
            <button type="button" class="btn btn-secondary" [disabled]="formSubmitting" (click)="back()">Cancel</button>
            <span *ngIf="globalTax.id">
              &nbsp;
              <button type="button" class="btn btn-danger" [disabled]="formSubmitting" (click)="delete()">Delete</button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
